<template>
<div id="printIp">
    <CompanyInfo></CompanyInfo>
    <div class="content-area">
  <div class="left-column">
    <p><span class="label">Reg No</span><span class="colon">:</span><span class="value">{{ patientId }}</span></p>
    <p><span class="label">Patient Name</span><span class="colon">:</span><span class="value">{{ patientDetails.name }}</span></p>
    <p><span class="label">Age</span><span class="colon">:</span><span class="value">{{ patientDetails.age }}</span></p>
    <p><span class="label">Sex</span><span class="colon">:</span><span class="value">{{ patientDetails.gender }}</span></p>
  </div>

  <div class="right-column">
    <p><span class="label">Doctor Name</span><span class="colon">:</span><span class="value">{{doctorName }}</span></p>
    <p><span class="label">Room No</span><span class="colon">:</span><span class="value">{{roomNo }}</span></p>
    <p><span class="label">IP Date</span><span class="colon">:</span><span class="value">{{formattedAppointmentDate}}</span></p>
  </div>
</div>


</div>
</template>

<script>
import CompanyInfo from '../components/CompanyInfo.vue';
export default {
    components: {
        CompanyInfo
    },

    props: {
        ipPrintData: {
            type: [Object, Array]
        },
        patientDetails: {
            type: [Object, Array]
        },
        // roomNo:[Number],
        // patientId:[Number],
        patientId:[Number,String],
        roomNo:[Number,String],
        doctorName:[String]
    },
      computed: {
    formattedAppointmentDate() {
      if (!this.ipPrintData.ipDate) return "";

      const [year, month, day] = this.ipPrintData.ipDate.split("-");
      return `${day}/${month}/${year}`;  // convert to DD/MM/YYYY
    },
      }


}

</script>
